package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_1
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_2
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_3
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_4
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_5
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_6
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_7
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_8
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_9
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_10
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_11
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_12
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_13
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_14
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_15
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_16
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_17
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_18
import gero.composeapp.generated.resources.exp_content_verbi_sostantivati_19
import gero.composeapp.generated.resources.exp_title_verbi_sostantivati
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_1
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_2
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_3
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_4
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_5
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_6
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_7
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_8
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_9
import gero.composeapp.generated.resources.quiz_verbi_sostantivati_10
import gero.composeapp.generated.resources.roast

fun getVerbiSostantivatiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_1,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_3,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_5,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_7,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_8,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_10,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_11,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_12,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_13,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_14,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_15,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_16,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_17,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_18,
            face = Faces.Happy,
            character = Characters.Masko,
            image = Res.drawable.roast,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_sostantivati,
            content = Res.string.exp_content_verbi_sostantivati_19,
            face = Faces.Happy,
            character = Characters.Alyn,
            image = Res.drawable.roast,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true,
        ),
    )
}

fun getVerbiSostantivatiQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_2,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_3,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_4,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_5,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_6,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_7,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_8,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_9,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_sostantivati_10,
            correct = false
        ),
    ).shuffled()
}
